module.exports = __webpack_public_path__ + "img/home.d879e9ee.png";